import { Pressable, Text, View } from "react-native";
import useDroitsStyles from "./Droits.styles";
import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons";
import { CardDroitProps } from "./Droits.types";

export default function CardDroit({config, codeNature, dotation, openModal}: CardDroitProps) {
  const { styles } = useDroitsStyles();
  if (!dotation) return null;

  return (
    <Pressable 
      key={codeNature}
      style={styles.modernCard}
      onPress={() => openModal(dotation, codeNature)}
      testID={`BT_DROIT_${codeNature}`}
    >
      <View style={styles.cardHeader}>
        <View style={styles.typeContainer}>
          <MaterialCommunityIcons 
            name={config.icon}
            size={30}
            color={dotation.natureAbsence.couleurHexa}
          />
          <Text style={[styles.typeTitle, { color: dotation.natureAbsence.couleurHexa }]}>
            {config.name}
          </Text>
        </View>
      </View>

      <View style={styles.mainInfo}>
        <View style={styles.primaryStat}>
          <Text style={styles.primaryLabel}>Il vous reste</Text>
          <Text style={[styles.primaryValue, { color: dotation.natureAbsence.couleurHexa }]}>
            {(dotation.reste || 0)} {config.unit}
          </Text>
        </View>
      </View>

      <View style={styles.quickStats}>
              
        <View style={styles.statItem}>
          <Text style={styles.statLabel}>Droit</Text>
          <Text style={styles.statValue}>{dotation.droit || 0}</Text>
        </View>
        <View style={styles.statItem}>
          <Text style={styles.statLabel}>Pris</Text>
          <Text style={styles.statValue}>{dotation.pris || 0}</Text>
        </View>
        <View style={styles.statItem}>
          <Text style={styles.statLabel}>Solde actuel</Text>
          <Text style={styles.statValue}>{dotation.solde || 0}</Text>
        </View>
       
        <View style={styles.statItem}>
          <Text style={styles.statLabel}>À venir</Text>
          <Text style={styles.statValue}>{dotation.pris_a_venir || 0}</Text>
        </View>
        
         <View style={styles.statItem}>
          <Text style={styles.statLabel}>À valider</Text>
          <Text style={styles.statValue}>{dotation.pris_a_valider || 0}</Text>
        </View>
      </View>

      {/* Alertes spécifiques */}
      {/* TODO: voir pour les échus{Number(dotation.echus) > 0 && (
        <View style={styles.warningInfo}>
          <Text style={styles.warningLabel}>
            ⚠️ {dotation.echus} jours échus
          </Text>
        </View>
      )} */}

      {dotation.complet?.droitN1 && Number(dotation.complet.droitN1) > 0 && (
        <View style={styles.nextYearInfo}>
          <Text style={styles.nextYearLabel}>Droits acquis pour N+1 : {dotation.complet.droitN1}</Text>
        </View>
      )}

      <Text style={styles.tapHint}>Appuyer pour voir le détail</Text>
    </Pressable>
  );
}